// extracted by mini-css-extract-plugin
module.exports = {"logo":"NavbarDefault_logo__ZN4G-"};